export default "__VITE_ASSET__BDQeIHtD__"